import { defaultIconProps, IconProps } from './IconProps';

export const IconFileCSV: import('react').FC<IconProps> = ({ size, color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 19" fill="none">
    <path
      d="M14.0833 9.5V4.75C14.0833 3.34987 14.0833 2.6498 13.8109 2.11502C13.5712 1.64462 13.1887 1.26217 12.7183 1.02248C12.1835 0.75 11.4835 0.75 10.0833 0.75H4.75C3.34987 0.75 2.6498 0.75 2.11502 1.02248C1.64462 1.26217 1.26217 1.64462 1.02248 2.11502C0.75 2.6498 0.75 3.34987 0.75 4.75V13.4167C0.75 14.8168 0.75 15.5169 1.02248 16.0516C1.26217 16.522 1.64462 16.9045 2.11502 17.1442C2.6498 17.4167 3.34983 17.4167 4.74988 17.4167H7.83333M9.08333 8.25H4.08333M5.75 11.5833H4.08333M10.75 4.91667H4.08333M9.91667 14.9167L12.4167 17.4167M12.4167 17.4167L14.9167 14.9167M12.4167 17.4167V12.4167"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

IconFileCSV.defaultProps = defaultIconProps;
